export async function initializeAdminWidget() {
  try {
    // Fetch user info
    const data = window.userControllerRegistry.data;
    const isHomePage = window.location.pathname === "/";
    const allowedPages = [
      "hotels/show",
      "hotels/index"
    ];

    if (!data) {
      console.error("User data not found.");
      return;
    }

    const currentPage = document.body.dataset.page;
    if(!allowedPages.includes(currentPage)) {return}

    // Define allowed roles
    const allowedRoles = ["is_admin"]; // Add more roles here in the future if needed


    // Check if the user's role is allowed
    if (data.authenticated && allowedRoles.includes(data.user.role)) {
      // Create the container
      const container = document.createElement("div");
      container.className = `fixed right-2.5 z-[1000] flex flex-col items-end ${
        isHomePage ? "top-2.5" : "top-[5.5rem]"
      }`;

      // Create the toggle button
      const toggleButton = document.createElement("button");
      toggleButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="minus_svg_feather minus_svg_feather-minus">
          <path d="M5 12h14"></path>
        </svg>`;
      toggleButton.className = "cursor-pointer";

      // Create the widget container
      const widget = document.createElement("div");
      widget.id = "admin-widget";
      widget.className = "hidden mt-2 w-40 bg-white border border-gray-300 rounded-lg shadow-lg p-2.5";

      // Create the content container
      const content = document.createElement("div");
      content.className = "flex flex-col gap-2";

      const currentPath = window.location.pathname;
      const hotelSlug = currentPath.split("/").pop();

      if(currentPage === "hotels/show") {
        // Edit Hotel
        const icon1 = document.createElement("span");
        const editUrl = `/admin/hotels/draft-${hotelSlug}/edit`; // Construct the new URL
        icon1.innerHTML = `
          <span>Editorial:</span>
          <a href="${editUrl}" title="Edit Hotel" class="flex items-center" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="edit_svg_feather edit_svg_feather-edit" viewBox="0 0 24 24" height="18">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </a>
          `;
        icon1.className = "mr-2.5 cursor-pointer grid grid-cols-2 gap-x-16";

        content.appendChild(icon1);
      }

      // Clear Cache
      const icon2 = document.createElement("span");
      const clearCacheUrl = `/admin/hotels/draft-${hotelSlug}`;
      icon2.innerHTML = `
        <span>Cache:</span>
        <a href="${clearCacheUrl}" title="Clear Cache" class="flex items-center">
          <svg class="broom_svg_svg-icon" style="vertical-align:middle;fill:currentColor;overflow:hidden" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" height="18">
            <path d="M989.59 246.293c45.845-45.888 45.845-120.554 0-166.442-22.273-22.23-51.798-34.475-83.243-34.475-31.424 0-60.992 12.224-82.496 33.792L606.229 277.44c-13.44 13.483-33.941 18.347-52.074 12.288l-119.616-39.893c-33.323-11.094-70.955-2.176-95.808 22.634L234.048 377.152c-4.01 3.99-6.25 9.43-6.25 15.104 0 5.675 2.24 11.093 6.25 15.104l408.747 408.747a21.208 21.208 0 0 0 15.082 6.272c5.504 0 10.966-2.048 15.126-6.294l104.704-104.661c25.258-25.195 33.92-61.91 22.634-95.787L760.47 496c-6.122-18.453-1.386-38.379 11.584-51.392L989.59 246.293zM719.914 509.547l39.829 119.616c6.123 18.41 1.408 38.378-12.288 52.074l-89.621 89.536-378.518-378.517 89.6-89.557c13.483-13.483 34.006-18.347 52.075-12.31l119.68 39.894c33.259 11.114 71.339 1.941 95.083-21.931L853.333 110.08c28.331-28.352 77.718-28.352 106.048 0 29.206 29.227 29.206 76.8.704 105.387L742.55 413.717c-25.301 25.216-33.962 61.931-22.634 95.83zM213.141 428.224c-8-8-22.229-8-30.229 0-42.752 42.795-124.544 83.392-169.088 100.224-6.805 2.624-11.819 8.448-13.333 15.53a21.354 21.354 0 0 0 5.781 19.606l408.79 408.79c4.074 4.031 9.535 6.271 15.103 6.271 2.539 0 5.078-.469 7.574-1.344 41.301-15.637 132.949-58.794 184.17-110.037 8.363-8.405 8.363-21.845 0-30.208L213.141 428.224zm222.166 504.021L59.05 555.968c40.725-18.219 97.386-48.17 138.325-83.03l378.453 378.454c-40.32 33.515-100.138 64.192-140.522 80.853z"></path>
            <path d="M896.427 210.56c19.968 0 36.16-16.17 36.16-36.139 0-19.925-16.256-36.117-36.16-36.096-19.862 0-36.054 16.15-36.054 36.096-.021 19.968 16.171 36.139 36.054 36.139z"></path>
          </svg>
        </a>
        `;
      icon2.className = "mr-2.5 cursor-pointer grid grid-cols-2 gap-x-16";

      content.appendChild(icon2);

      // Add toggle functionality
      toggleButton.addEventListener("click", () => {
        widget.classList.toggle("hidden");
      });

      // Append elements to the container
      widget.appendChild(content);
      container.appendChild(toggleButton);
      container.appendChild(widget);

      // Append the container to the body
      document.body.appendChild(container);
    }
  } catch (error) {
    console.error("Failed to initialize admin widget:", error);
  }
};
